var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDate = function SvgDate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.565 2.412V1H14.87v1.412H9.129V1H7.435v1.412H0v20.33h24V2.411h-7.435zm-9.13 1.694v1.412H9.13V4.106h5.742v1.13h1.694v-1.13h5.74v2.823H1.696V4.106h5.74zm-5.74 16.941V8.624h20.61v12.423H1.696zm3.81-2.259H8.33v-2.823H5.506v2.823zm5.083 0h2.824v-2.823h-2.824v2.823zm5.083 0h2.823v-2.823h-2.823v2.823zm-5.083-5.082h2.824v-2.824h-2.824v2.824zm5.083 0h2.823v-2.824h-2.823v2.824zm-10.165 0h2.823v-2.824H5.506v2.824z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};
export default SvgDate;